const state = {
    documents: [],
    documentTypes: [],
    policyDocuments: [],
    insurancePolicyDocumentType: null,
    insuranceSelectionDocumentType: null
};

const getters = {
    getDocuments: state => state.documents,
    getDocumentTypes: state => state.documentTypes,
    getPolicyDocuments: state => state.policyDocuments,
    getInsurancePolicyDocumentType: state => state.insurancePolicyDocumentType,
    getInsuranceSelectionDocumentType: state =>
        state.insuranceSelectionDocumentType
};

const mutations = {
    setDocuments(state, documents) {
        state.documents = documents;
    },
    setDocumentTypes(state, documentTypes) {
        state.documentTypes = documentTypes;
    },
    setPolicyDocuments(state, documents) {
        state.policyDocuments = documents;
    },
    setInsurancePolicyDocumentType(state, documenType) {
        state.insurancePolicyDocumentType = documenType;
    },
    setInsuranceSelectionDocumentType(state, documenType) {
        state.insuranceSelectionDocumentType = documenType;
    }
};

const actions = {
    async getDocumentTypes({commit}, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.get(`/api/v3/documents`, {
                    headers: {
                        Authorization: `Bearer ${payload.token}`
                    }
                });
                commit("setDocumentTypes", res.data);

                // find the selection and policy insurance id
                res.data.forEach(data => {
                    if (data.name == "Insurance Policy Document")
                        commit("setInsurancePolicyDocumentType", data);
                    else if (data.name == "Insurance Selection Document")
                        commit("setInsuranceSelectionDocumentType", data);
                });
                resolve(res.data);
            } catch (Err) {
                reject(Err);
            }
        });
    },
    async getDocuments({
                           commit
                       }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.get(
                    `/api/application/${payload.application_id}/finalise/documents`, {
                        headers: {
                            Authorization: `Bearer ${payload.token}`
                        },
                        params: {
                            excludes: "pdf_versions"
                        }
                    }
                );

                commit("setDocuments", res.data.documents);
                resolve(res.data);
            } catch (Err) {
                reject(Err);
            }
        });
    },
    async getPolicyDocuments({
                                 commit,
                                 dispatch
                             }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const docs = await dispatch("getDocuments", payload);

                const policyDocs = docs.documents.filter(
                    d => d.document_type_id == payload.document_type_id
                );

                commit("setPolicyDocuments", policyDocs);
                resolve(policyDocs);
            } catch (err) {
                reject(err);
            }
        });
    },
    async viewDocument({
                           commit
                       }, payload) {
        return new Promise(async (resolve, reject) => {
            axios
                .get(
                    "/api/application/" +
                    payload.application_id +
                    "/finalise/documents/" +
                    payload.document_id +
                    "?is_app_document=0", {
                        headers: {
                            Authorization: `Bearer ${payload.token}`
                        }
                    }
                )
                .then(res => resolve(res.data))
                .catch(err => {
                    reject(err);
                });
        });
    },
    async deleteDocument({
                             commit,
                             dispatch
                         }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.delete(
                    `/api/application/${payload.application_id}/finalise/documents/${payload.document_id}`, {
                        headers: {
                            Authorization: `Bearer ${payload.token}`
                        },
                        data: {
                            is_app_document: false
                        }
                    }
                );

                await dispatch("getDocuments", payload);
                resolve(res.data);
            } catch (Err) {
                reject(Err);
            }
        });
    },
    async updateDocument({
                             commit,
                             dispatch
                         }, payload) {
        const doc = payload.document;
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios
                    .put(
                        "/api/application/" +
                        payload.application_id +
                        "/finalise/documents/" +
                        payload.document_id, {
                            document_type_id: doc.document_type_id,
                            status: doc.status,
                            is_app_document: doc.is_app_document,
                            document_category: doc.doc_category,
                            file_name: doc.filename
                        }, {
                            headers: {
                                Authorization: `Bearer ${payload.token}`
                            }
                        }
                    )
                await dispatch("getDocuments", payload);
                resolve(res.data);
            } catch (err) {
                reject(err);
            }
            ;
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
